import React from 'react';
interface StatCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  icon?: React.ReactNode;
}
export function StatCard({
  label,
  value,
  subtext,
  icon
}: StatCardProps) {
  return <div className="bg-slate-800 rounded-xl p-4 border border-slate-700 flex flex-col justify-between h-full" data-id="element-60">
      <div className="flex justify-between items-start mb-2" data-id="element-61">
        <span className="text-slate-400 text-xs font-medium uppercase tracking-wider" data-id="element-62">
          {label}
        </span>
        {icon && <div className="text-blue-400" data-id="element-63">{icon}</div>}
      </div>
      <div data-id="element-64">
        <div className="text-2xl font-bold text-white" data-id="element-65">{value}</div>
        {subtext && <div className="text-xs text-slate-500 mt-1" data-id="element-66">{subtext}</div>}
      </div>
    </div>;
}